// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"styles__wrapper___U_vSC"};


//////////////////
// WEBPACK FOOTER
// ./components/qual/Table/CorruptTableLayer/styles.scss
// module id = UNHa
// module chunks = 0